import { rest } from 'msw'

import { config } from '@percent/admin-dashboard/config'
import { mockDisbursementBatchProgress } from '@percent/admin-dashboard/fixtures/api/disbursements/mockDisbursementBatchProgress'
import { mockDisbursementsList } from '@percent/admin-dashboard/fixtures/api/disbursements/mockDisbursementsList'

export const disbursementsHandlers = [
  rest.get(`${config.urls.api}v1/admin/disbursement-batches`, async (_, res, ctx) =>
    res(ctx.status(200), ctx.json(mockDisbursementsList))
  ),
  rest.get(`${config.urls.api}v1/admin/disbursement-batches/:disbursementBatchId/progress`, async (_, res, ctx) =>
    res(ctx.status(200), ctx.json(mockDisbursementBatchProgress))
  ),
  rest.patch(`${config.urls.api}v1/admin/disbursement-batches/:disbursementBatchId`, async (req, res, ctx) => {
    const { name } = await req.json()

    return res(
      ctx.status(200),
      ctx.json({ data: { id: req.params.disbursementBatchId, name }, object: 'disbursement_batch' })
    )
  }),
  rest.post(`${config.urls.api}v1/admin/disbursements/:disbursementId/log-return`, async (_, res, ctx) => {
    return res(ctx.status(200), ctx.json({ success: true }))
  }),
  rest.post(
    `${config.urls.api}v1/admin/disbursement-batches/:disbursementBatchId/trustee-approve`,
    async (_, res, ctx) => {
      return res(ctx.status(200), ctx.json({ data: {}, object: 'disbursement_batch' }))
    }
  ),
  rest.post(
    `${config.urls.api}v1/admin/disbursement-batches/:disbursementBatchId/agent-approve`,
    async (_, res, ctx) => {
      return res(ctx.status(200), ctx.json({ data: {}, object: 'disbursement_batch' }))
    }
  ),
  rest.post(
    `${config.urls.api}v1/admin/disbursement-batches/:disbursementBatchId/manager-approve`,
    async (_, res, ctx) => {
      return res(ctx.status(200), ctx.json({ data: {}, object: 'disbursement_batch' }))
    }
  ),
  rest.post(`${config.urls.api}v1/admin/disbursements/bulk-approve`, async (req, res, ctx) => {
    const { disbursementIds } = await req.json()

    return res(ctx.status(200), ctx.json({ data: { succeeded: disbursementIds, failed: [] } }))
  }),
  rest.post(`${config.urls.api}v1/admin/disbursements/bulk-in-transit`, async (req, res, ctx) => {
    const { disbursementIds } = await req.json()

    return res(ctx.status(200), ctx.json({ data: { succeeded: disbursementIds, failed: [] } }))
  }),
  rest.post(`${config.urls.api}v1/admin/disbursements/bulk-cancel`, async (req, res, ctx) => {
    const { disbursementIds } = await req.json()

    return res(ctx.status(200), ctx.json({ data: { succeeded: disbursementIds, failed: [] } }))
  }),
  rest.post(`${config.urls.api}v1/admin/disbursements/bulk-mark-as-paid`, async (req, res, ctx) => {
    const body = await req.json()

    if (body.dryRun) {
      return res(
        ctx.status(200),
        ctx.json({
          data: { succeeded: 0, skipped: [], validDisbursementIds: [] },
          object: 'bulk_mark_as_paid_result'
        })
      )
    }

    return res(
      ctx.status(200),
      ctx.json({
        data: { succeeded: 0, skipped: [] },
        object: 'bulk_mark_as_paid_result'
      })
    )
  })
]
